<template>
  <view wx:if="{{locateCity}}" class="hot-city-main">
    <view style="height:22px"></view>
    <view class="city-title">{{title}}</view>
    <view class="city-container" bindtap="handleClick">
      <image class="location-icon" mode="widthFix" src="https://ut-static.udache.com/webx/sfc/vIFowsTluWuy9ZjCqSrH6_image.png"></image>
      <view class="location-item">{{locateCity.city_name}}</view>
    </view>
  </view>
</template>

<script>
import { createComponent } from '@mpxjs/core'
import { locate } from '@didi/spring-base'

createComponent({
  async created() {
    const { cityId } = await locate()
    for(let item of this.list) {
      for(let city of item.city_list) {
        if(city._cityId === cityId) {
          this.locateCity = city
          break
        }
      }
      if(this.locateCity) {
        break
      }
    }
  },
  props: {
    list: {
      type: Array,
      value: []
    },
    title: '',
  },
  data() {
    return {
      locateCity: null
    }
  },
  methods: {
    handleClick(city) {
      this.triggerEvent('handle', this.locateCity)
    }
  }
})
</script>

<style scoped lang="stylus" scoped>
.hot-city-main
  margin-left 17px
  margin-right 14px
  font-size 14px
  font-weight normal
  color #333333
  font-family PingFangSC-Semibold
.city-container
  margin-top 12px
  background #F6F7F8
  border-radius 8px
  font-size 14px
  font-weight 400
  color #000000
  font-family PingFangSC
  height 36px
  box-sizing border-box
  padding 0 4px
  display inline-flex
  width auto
  align-items center
  justify-content center
  min-width calc((100% - 16px) / 3)
  .location-icon
    width 16px
    margin-right 2px
  .location-item
    width auto
.city-item
  height 35px
  line-height 35px
  background #FCFCFD
  border 1px solid #E5E5E5
  border-radius 8px
  text-align center
</style>
<script name='json'>
module.exports = {
  component: true,
  usingComponents: {}
}
</script>
